import * as yup from 'yup';

const phoneRegex = /^\+[1-9]\d{0,2}$/;
const dayEnum = [1, 2, 3, 4, 5, 6, 7];

const benefitSchema = yup.object().shape({
  description: yup.string()
    .max(500, 'La descripción no puede exceder los 500 caracteres')
    .required('La descripción es requerida'),
  title: yup.string()
    .max(500, 'El título no puede exceder los 500 caracteres')
    .required('El título es requerido'),
  coupon: yup.string().nullable(),
  id: yup.number()
    .integer('El ID debe ser un número entero')
    .positive('El ID debe ser positivo')
    .nullable()
});

const timeSlotSchema = yup.object().shape({
  day: yup.number()
    .oneOf(dayEnum, 'Día inválido. Debe estar entre 1 y 7')
    .required('El día es requerido'),
  from: yup.string()
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Formato de hora inválido (HH:mm)')
    .required('La hora de inicio es requerida'),
  to: yup.string()
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Formato de hora inválido (HH:mm)')
    .required('La hora de fin es requerida')
});

const companyBranchSchema = yup.object().shape({
  name: yup.string()
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .max(100, 'El nombre no puede exceder los 100 caracteres')
    .required('El nombre es requerido'),
  company_branch_status_id: yup.number()
    .integer('El estado debe ser un número entero')
    .positive('El estado debe ser positivo')
    .required('El estado es requerido'),
  is_pick_up_point: yup.boolean()
    .required('Debe indicar si es punto de recogida'),
  email: yup.string()
    .email('Correo electrónico inválido')
    .nullable(true),
  phone_country_code: yup.string()
    .matches(phoneRegex, 'Código de país inválido (ejemplo: +34)')
    .optional()
    .nullable(true),
  phone_area_code: yup.string()
    .test(
      'digits-between',
      'El código de área debe tener entre 2 y 5 dígitos',
      value => !value || /^\d{2,5}$/.test(value)
    )
    .optional()
    .nullable(true),
  phone_number: yup.string()
    .test(
      'digits-between',
      'El número de teléfono debe tener entre 6 y 10 dígitos',
      value => !value || /^\d{6,10}$/.test(value)
    )
    .optional()
    .nullable(true),
  whatsapp_country_code: yup.string()
    .matches(phoneRegex, 'Código de país de WhatsApp inválido (ejemplo: +34)')
    .optional()
    .nullable(true),
  whatsapp_area_code: yup.string()
    .test(
      'digits-between',
      'El código de área de WhatsApp debe tener entre 2 y 5 dígitos',
      value => !value || /^\d{2,5}$/.test(value)
    )
    .optional()
    .nullable(true),
  whatsapp_number: yup.string()
    .test(
      'digits-between',
      'El número de WhatsApp debe tener entre 6 y 10 dígitos',
      value => !value || /^\d{6,10}$/.test(value)
    )
    .optional()
    .nullable(true),
  lat: yup.number()
    .required('La latitud es requerida')
    .typeError('La latitud debe ser un número'),
  lng: yup.number()
    .required('La longitud es requerida')
    .typeError('La longitud debe ser un número'),
  address: yup.string()
    .max(500, 'La dirección no puede exceder los 500 caracteres')
    .required('La dirección es requerida'),
  zip_code: yup.string()
    .matches(/^\d{4}$/, 'El código postal debe tener exactamente 4 dígitos')
    .nullable(true),
  instagram_handle: yup.string()
    .min(3, 'El handle de Instagram debe tener al menos 3 caracteres')
    .max(100, 'El handle de Instagram no puede exceder los 100 caracteres')
    .nullable(true),
  facebook_url: yup.string()
    .url('URL de Facebook inválida')
    .min(3, 'La URL debe tener al menos 3 caracteres')
    .max(100, 'La URL no puede exceder los 100 caracteres')
    .nullable(true),
  website_url: yup.string()
    .url('URL del sitio web inválida')
    .min(3, 'La URL debe tener al menos 3 caracteres')
    .max(100, 'La URL no puede exceder los 100 caracteres')
    .nullable(true),
  services: yup.array()
    .of(yup.number().integer('Los servicios deben ser números enteros'))
    .required('Los servicios son requeridos')
    .min(1, 'Debe haber al menos un servicio'),
  time_slots: yup.array()
    .of(timeSlotSchema)
    .nullable(true)
    .min(1, 'Debe haber al menos un horario'),
  benefits: yup.array()
    .of(benefitSchema)
    .required('Los beneficios son requeridos')
    
});

export default companyBranchSchema